import { Button, Collapse, FlagHollowSVG } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent } from "@newsela/snitch";
import ReportContentForm from "@/view/ReportContentForm";
import useReportContent from "@/view/utils/useReportContent";
import {
  reportContentButtonContainerCss,
  reportContentButtonCss,
} from "./ReportContent.style";

const ButtonWithTrackEvent = withTrackEvent(Button);

const propTypes = {
  contentId: PropTypes.string,
};

const ReportContent = ({ contentId }) => {
  const { isHidden, onClick: setIsHidden } = Collapse.useCollapse({
    isHidden: true,
  });
  const {
    handleCancelReport,
    handleSubmitReport,
    handleTextAreaChange,
    problemDescription,
  } = useReportContent();

  return (
    <>
      <Collapse
        isHidden={isHidden}
        timeout={0}
        renderCustomTrigger={() => (
          <div style={reportContentButtonContainerCss}>
            <ButtonWithTrackEvent
              __cssFor={{ root: reportContentButtonCss }}
              ariaProps={{
                "aria-controls": "report-content-form",
                "aria-expanded": !isHidden,
              }}
              flavor={Button.flavors.tertiary}
              icon={{
                SvgComponent: FlagHollowSVG,
                alignment: Button.iconAlignments.left,
              }}
              onClick={setIsHidden}
              dataProps={{
                "data-qa-selector": "report_problem_gen_write_prompts",
              }}
              streamProperties={{
                description:
                  "Report problem with content from generated write prompts",
              }}
            >
              Report content
            </ButtonWithTrackEvent>
          </div>
        )}
      >
        <ReportContentForm
          ariaProps={{
            "aria-controls": "report-content-form",
            "aria-expanded": !isHidden,
          }}
          handleCancelReport={() => {
            handleCancelReport();
            setIsHidden();
          }}
          handleSubmitReport={() => {
            handleSubmitReport({ contentId });
            setIsHidden();
          }}
          handleTextAreaChange={handleTextAreaChange}
          id="report-content-form"
          isHidden={isHidden}
          textAreaValue={problemDescription}
        />
      </Collapse>
    </>
  );
};

ReportContent.propTypes = propTypes;

export default ReportContent;
